import { Button } from 'semantic-ui-react';
import { useHistory } from 'react-router-dom';
import { NEW_SERVICE_PATH } from './serviceFormUtils';

const CreateService = ({ eventSlugname }) => {
  const history = useHistory();

  return (
    <Button secondary onClick={() => history.push(NEW_SERVICE_PATH, { eventSlugname })}>
      Crear Evento
    </Button>
  );
};

export default CreateService;
